import { useCallback } from 'react';
import { Box } from 'foundations-components/transitional/components/Box';
import { Select } from 'foundations-components/transitional/components/Select';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { getRoutingTypeOptions } from '../constants/RoutingRulesSelectOptions';
import { KEEP_ASSIGNEE } from '../constants/RoutingTypes';
import NoAccessToInboxTooltip from './tooltips/NoAccessToInboxTooltip';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const SelectAssignmentGroup = ({
  aiChatbotId,
  anyAvailableUser,
  currentGroup,
  disabled,
  disableKeepAssignee,
  menuWidth = 250,
  onChange,
  onOpenChange,
  showAnyUser,
  showKeepAssignee,
  showTeamsOnly,
  showUnassigned,
  showOwner
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal('livemessages-routing');
  const itemComponent = useCallback(itemComponentProps => {
    if (disableKeepAssignee && itemComponentProps.option.value === KEEP_ASSIGNEE) {
      return /*#__PURE__*/_jsx(NoAccessToInboxTooltip, {
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: itemComponentProps.children
        })
      });
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: itemComponentProps.children
    });
  }, [disableKeepAssignee]);
  return /*#__PURE__*/_jsx(Box, {
    basis: 240,
    grow: 0,
    children: /*#__PURE__*/_jsx(Select, {
      "data-test-id": "select-assignment-group",
      disabled: disabled,
      defaultOpen: false,
      itemComponent: itemComponent,
      options: getRoutingTypeOptions({
        anyAvailableUser,
        disableKeepAssignee,
        showAnyUser,
        showKeepAssignee,
        showTeamsOnly,
        showUnassigned,
        showOwner,
        aiChatbotId
      }),
      searchable: false,
      value: currentGroup,
      menuWidth: menuWidth,
      onChange: onChange,
      onOpenChange: onOpenChange,
      onSelectedOptionChange: e => {
        if (e.target.value.locked) {
          openUpgradeModal();
        }
      }
    })
  }, currentGroup);
};
SelectAssignmentGroup.displayName = 'SelectAssignmentGroup';
export default SelectAssignmentGroup;